import { render, staticRenderFns } from "./TaskMainJobList.vue?vue&type=template&id=63154de8&scoped=true"
import script from "./TaskMainJobList.vue?vue&type=script&lang=js"
export * from "./TaskMainJobList.vue?vue&type=script&lang=js"
import style0 from "./TaskMainJobList.vue?vue&type=style&index=0&id=63154de8&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63154de8",
  null
  
)

export default component.exports